// Shared CRM enums + helpers (single source of truth for the frontend).
// Keep in sync with /app/backend/crm.py.

export const CATEGORIES = [
  "Psychologist",
  "Psychiatrist",
  "MentalHealthClinic",
  "AIHealthTech",
  "UniversityResearcher",
  "InvestorAccelerator",
  "PublicHealthMunicipality",
  "PotentialUser",
  "PilotPartner",
  "Other",
];

export const STATUSES = [
  "New",
  "Reviewed",
  "Interested",
  "DemoSent",
  "FollowUpNeeded",
  "PilotCandidate",
  "Converted",
  "NotInterested",
];

export const OUTREACH_STAGES = [
  "NotStarted",
  "FirstMessageDrafted",
  "FirstMessageSent",
  "FollowUpNeeded",
  "FollowUpSent",
  "DemoInvited",
  "DemoSent",
  "MeetingBooked",
  "PilotDiscussion",
  "Converted",
  "Closed",
];

export const ACTIVITY_TYPES = [
  "NOTE",
  "EMAIL",
  "CALL",
  "FOLLOW_UP",
  "DEMO",
  "STATUS_CHANGE",
  "STAGE_CHANGE",
  "AI_MESSAGE_GENERATED",
  "TASK_CREATED",
  "TASK_COMPLETED",
  "IMPORT",
  "CONTACT_FORM",
];

export const STATUS_TONE = {
  New: "bg-slate-100 text-slate-700 ring-slate-200",
  Reviewed: "bg-slate-100 text-slate-700 ring-slate-200",
  Interested: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  DemoSent: "bg-cyan-50 text-cyan-700 ring-cyan-200",
  FollowUpNeeded: "bg-amber-50 text-amber-700 ring-amber-200",
  PilotCandidate: "bg-indigo-50 text-indigo-700 ring-indigo-200",
  Converted: "bg-emerald-100 text-emerald-800 ring-emerald-300",
  NotInterested: "bg-rose-50 text-rose-700 ring-rose-200",
};

export const STAGE_TONE = {
  NotStarted: "bg-slate-50 text-slate-600 ring-slate-200",
  FirstMessageDrafted: "bg-slate-100 text-slate-700 ring-slate-200",
  FirstMessageSent: "bg-cyan-50 text-cyan-700 ring-cyan-200",
  FollowUpNeeded: "bg-amber-50 text-amber-700 ring-amber-200",
  FollowUpSent: "bg-indigo-50 text-indigo-700 ring-indigo-200",
  DemoInvited: "bg-cyan-50 text-cyan-700 ring-cyan-200",
  DemoSent: "bg-cyan-100 text-cyan-800 ring-cyan-300",
  MeetingBooked: "bg-indigo-100 text-indigo-800 ring-indigo-300",
  PilotDiscussion: "bg-indigo-100 text-indigo-800 ring-indigo-300",
  Converted: "bg-emerald-100 text-emerald-800 ring-emerald-300",
  Closed: "bg-slate-200 text-slate-700 ring-slate-300",
};

export function formatRel(iso) {
  if (!iso) return "—";
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return iso;
  const diff = Date.now() - ts;
  const sec = Math.round(diff / 1000);
  const min = Math.round(sec / 60);
  const hr = Math.round(min / 60);
  const day = Math.round(hr / 24);
  if (Math.abs(sec) < 60) return "just now";
  if (Math.abs(min) < 60) return `${min}m ago`;
  if (Math.abs(hr) < 24) return `${hr}h ago`;
  if (Math.abs(day) < 31) return `${day}d ago`;
  return new Date(iso).toLocaleDateString();
}

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || "").join("");
}
